// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"52496e5f","441":"d728646d","639":"694abd2e","747":"13dbc163"}[chunkId] + ".chunk.js";
};